(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ampema-price-notice"] && !Shopify.designMode) return;
  try {
    function positionAmpemaTaxLabel() {
    document.querySelectorAll('[data-ampema-tax-label]').forEach((label) => {
      const container = label.closest('.product__info-container');
      const price = container ? container.querySelector('[id^="price-"]') : null;
      if (!container || !price) return;

      container.querySelectorAll('.caption').forEach((caption) => {
        const text = caption.textContent.replace(/\s+/g, ' ').trim().toLowerCase();
        if (text === '(eks. mva)' || text.startsWith('alle priser vises eks. mva')) {
          caption.remove();
        }
      });

      price.insertAdjacentElement('afterend', label);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', positionAmpemaTaxLabel);
  } else {
    positionAmpemaTaxLabel();
  }

  document.addEventListener('shopify:section:load', positionAmpemaTaxLabel);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ampema-product-conversion"] && !Shopify.designMode) return;
  try {
    function enhanceAmpemaProductOffer() {
    document.querySelectorAll('[data-ampema-product-proof]').forEach((proof) => {
      const container = proof.closest('.product__info-container');
      if (!container) return;

      const title = container.querySelector('.product__title');
      const rating = proof.querySelector('.ampema-product-proof__rating');
      if (title && rating && !container.querySelector('.ampema-title-rating')) {
        const titleRating = rating.cloneNode(true);
        titleRating.classList.add('ampema-title-rating');
        title.insertAdjacentElement('afterend', titleRating);
      }

      const fieldsets = Array.from(container.querySelectorAll('fieldset'));
      const lengthFieldset = fieldsets.find((fieldset) => {
        const legend = fieldset.querySelector('legend');
        return legend && legend.textContent.replace(/\s+/g, ' ').trim().toLowerCase().startsWith('lengde på motiv');
      });

      if (lengthFieldset && !lengthFieldset.querySelector('.ampema-package-value')) {
        const packageInput = Array.from(lengthFieldset.querySelectorAll('input[type="radio"]')).find((input) =>
          input.value.toLowerCase().includes('sjablongpakke')
        );
        const packageLabel = packageInput && lengthFieldset.querySelector(`label[for="${CSS.escape(packageInput.id)}"]`);
        if (packageLabel) {
          packageLabel.innerHTML = '<span class="ampema-package-value"><strong>Sjablongpakke – mest verdi</strong><small>10 + 30 + 60 cm · Spar <span data-ampema-package-saving>300</span> kr</small></span>';
        }
      }

      const logoFieldset = fieldsets.find((fieldset) => {
        const legend = fieldset.querySelector('legend');
        return legend && legend.textContent.replace(/\s+/g, ' ').trim().toLowerCase().startsWith('egen logo med bilde');
      });
      const packageSaving = lengthFieldset && lengthFieldset.querySelector('[data-ampema-package-saving]');
      const updatePackageSaving = () => {
        if (!logoFieldset || !packageSaving) return;
        const selectedLogo = logoFieldset.querySelector('input[type="radio"]:checked');
        const saving = selectedLogo && selectedLogo.value.trim().toLowerCase() === 'ja' ? '600' : '300';
        if (packageSaving.textContent !== saving) packageSaving.textContent = saving;
      };
      updatePackageSaving();

      if (container.dataset.ampemaPackageSavingReady !== 'true') {
        container.addEventListener('change', (event) => {
          if (!event.target.matches('input[type="radio"]')) return;
          window.setTimeout(enhanceAmpemaProductOffer, 0);
          window.setTimeout(enhanceAmpemaProductOffer, 300);
        });

        const variantObserver = new MutationObserver(() => {
          window.requestAnimationFrame(enhanceAmpemaProductOffer);
        });
        variantObserver.observe(container, { childList: true, subtree: true });
        container.dataset.ampemaPackageSavingReady = 'true';
      }

      const instructions = container.querySelector('[id^="instructions-section-"]');
      if (instructions && !instructions.querySelector('.ampema-instructions-disclosure')) {
        const details = document.createElement('details');
        details.className = 'ampema-instructions-disclosure';
        const summary = document.createElement('summary');
        summary.textContent = 'Har du spesielle ønsker? (valgfritt)';
        const content = document.createElement('div');
        content.className = 'ampema-instructions-disclosure__content';
        while (instructions.firstChild) content.appendChild(instructions.firstChild);
        details.append(summary, content);
        instructions.appendChild(details);
      }
    });
  }

  function initAmpemaProductOfferObserver() {
    if (!document.body || document.body.dataset.ampemaOfferObserverReady === 'true') return;

    let refreshQueued = false;
    const observer = new MutationObserver((mutations) => {
      const productContentChanged = mutations.some((mutation) => {
        const target = mutation.target.nodeType === Node.ELEMENT_NODE
          ? mutation.target
          : mutation.target.parentElement;
        if (target && target.closest('.product__info-container, product-info, variant-selects, fieldset')) return true;

        return Array.from(mutation.addedNodes).some((node) => {
          if (node.nodeType !== Node.ELEMENT_NODE) return false;
          return node.matches('.product__info-container, product-info, variant-selects, fieldset')
            || node.querySelector('[data-ampema-product-proof], .product__info-container, variant-selects, fieldset');
        });
      });

      if (!productContentChanged || refreshQueued) return;
      refreshQueued = true;
      window.requestAnimationFrame(() => {
        refreshQueued = false;
        enhanceAmpemaProductOffer();
        positionAmpemaInstructions();
      });
    });

    observer.observe(document.body, { childList: true, subtree: true });
    document.body.dataset.ampemaOfferObserverReady = 'true';
  }

  function positionAmpemaInstructions() {
    document.querySelectorAll('[data-ampema-product-proof]').forEach((proof) => {
      const container = proof.closest('.product__info-container');
      if (!container) return;

      const instructions = container.querySelector('[id^="instructions-section-"]');
      const quantity = container.querySelector('.product-form__quantity');
      const oldFacts = container.querySelector('.ampema-purchase-facts');

      if (oldFacts) oldFacts.remove();
      if (!instructions || !quantity || instructions.nextElementSibling === quantity) return;

      quantity.insertAdjacentElement('beforebegin', instructions);
      instructions.dataset.ampemaMoved = 'true';
    });
  }

  function initAmpemaProductGallery() {
    document.querySelectorAll('media-gallery').forEach((gallery) => {
      if (gallery.dataset.ampemaGalleryReady === 'true') return;

      const mediaItems = Array.from(gallery.querySelectorAll('.product__media-item'));
      const thumbnailItems = Array.from(gallery.querySelectorAll('.thumbnail-list__item'));
      if (!mediaItems.length || !thumbnailItems.length) return;

      thumbnailItems.forEach((thumbnailItem) => {
        const originalButton = thumbnailItem.querySelector('.thumbnail');
        const targetId = `Slide-${thumbnailItem.dataset.target}`;
        const target = mediaItems.find((mediaItem) => mediaItem.id === targetId);
        if (!originalButton || !target) return;

        const button = originalButton.cloneNode(true);
        originalButton.replaceWith(button);

        button.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopImmediatePropagation();

          mediaItems.forEach((mediaItem) => {
            if (mediaItem === target) {
              mediaItem.classList.add('is-active');
            } else {
              mediaItem.classList.remove('is-active');
            }
          });

          thumbnailItems.forEach((item) => {
            const itemButton = item.querySelector('.thumbnail');
            if (!itemButton) return;

            if (item === thumbnailItem) {
              itemButton.setAttribute('aria-current', 'true');
            } else {
              itemButton.removeAttribute('aria-current');
            }
          });

          if (window.matchMedia('(max-width: 749px)').matches) {
            target.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
          }
        }, true);
      });

      gallery.dataset.ampemaGalleryReady = 'true';
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enhanceAmpemaProductOffer);
    document.addEventListener('DOMContentLoaded', initAmpemaProductOfferObserver);
    document.addEventListener('DOMContentLoaded', positionAmpemaInstructions);
    document.addEventListener('DOMContentLoaded', initAmpemaProductGallery);
  } else {
    enhanceAmpemaProductOffer();
    initAmpemaProductOfferObserver();
    positionAmpemaInstructions();
    initAmpemaProductGallery();
  }

  document.addEventListener('shopify:section:load', enhanceAmpemaProductOffer);
  document.addEventListener('shopify:section:load', initAmpemaProductOfferObserver);
  document.addEventListener('shopify:section:load', positionAmpemaInstructions);
  document.addEventListener('shopify:section:load', initAmpemaProductGallery);
  } catch(e) { console.error(e); }
})();

})();
